import { z } from "zod";

export const agentSkillStateSchema = z.enum([
  "available",
  "configured",
  "installed",
  "missing",
  "stale",
  "external",
]);

export const agentSkillOriginSchema = z.preprocess((value) => {
  if (value === "company_managed") return "organization_managed";
  return value;
}, z.enum([
  "organization_managed",
  "user_installed",
  "external_unknown",
]));

export const agentSkillSourceClassSchema = z.enum([
  "bundled",
  "organization",
  "agent_home",
  "global",
  "adapter_home",
]);

export const agentSkillSyncModeSchema = z.enum([
  "unsupported",
  "persistent",
  "ephemeral",
]);

export const agentSkillEntrySchema = z.object({
  key: z.string().min(1),
  selectionKey: z.string().min(1),
  runtimeName: z.string().min(1).nullable(),
  description: z.string().nullable().optional(),
  desired: z.boolean(),
  configurable: z.boolean(),
  alwaysEnabled: z.boolean(),
  managed: z.boolean(),
  state: agentSkillStateSchema,
  sourceClass: agentSkillSourceClassSchema,
  origin: agentSkillOriginSchema.optional(),
  originLabel: z.string().nullable().optional(),
  locationLabel: z.string().nullable().optional(),
  readOnly: z.boolean().optional(),
  sourcePath: z.string().nullable().optional(),
  targetPath: z.string().nullable().optional(),
  workspaceEditPath: z.string().nullable().optional(),
  detail: z.string().nullable().optional(),
});

export const agentSkillSnapshotSchema = z.object({
  agentRuntimeType: z.string().min(1),
  supported: z.boolean(),
  mode: agentSkillSyncModeSchema,
  desiredSkills: z.array(z.string().min(1)),
  entries: z.array(agentSkillEntrySchema),
  warnings: z.array(z.string()),
});

export const agentSkillSyncSchema = z.object({
  desiredSkills: z.array(z.string().min(1)),
});

export const agentSkillEnableSchema = z.object({
  skills: z.array(z.string().min(1)).min(1),
});

export type AgentSkillSync = z.infer<typeof agentSkillSyncSchema>;
export type AgentSkillEnable = z.infer<typeof agentSkillEnableSchema>;
